/* ==========================================================================
   BM custom: INLINE engraving preview (version B - for comparison)
   The chosen symbol is shown INSIDE the text box, right after the typed text,
   and the typed text itself is shown in the chosen font. The separate preview
   row under the box is hidden.

   Turned on (per page) when EITHER:
     - the product has the tag  engr_inline_preview   (snippet sets data-inline-preview="true")
     - or the URL has  ?bm_inline=1   (quick A/B check; ?bm_inline=0 forces it off)
   Otherwise this file does nothing and version A (preview row) stays as-is.

   Loaded after bm-engraving.js + bm-engraving-font.js. Does not change what is
   saved on the order - it only changes how the choice is displayed.
   ========================================================================== */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    var root = document.querySelector('.bm-engraving');
    if (!root) return;
    var single = root.querySelector('[data-symbol-mode="single"]');
    var picker = root.querySelector('[data-bm-font-picker]');
    if (!single || !picker) return;

    // ?bm_inline=1 is remembered for the browsing session (sessionStorage), so version B stays on
    // after a Ring style switch or any other page change that drops the URL parameter.
    // ?bm_inline=0 turns it off again.
    var STORE_KEY = 'bmInlinePreview';
    var param = new URLSearchParams(window.location.search).get('bm_inline');
    try {
      if (param === '1') window.sessionStorage.setItem(STORE_KEY, '1');
      if (param === '0') window.sessionStorage.removeItem(STORE_KEY);
    } catch (e) { /* storage blocked - URL parameter still works for this page */ }
    var remembered = false;
    try { remembered = window.sessionStorage.getItem(STORE_KEY) === '1'; } catch (e) {}
    var enabled = param !== '0' && (param === '1' || remembered || picker.getAttribute('data-inline-preview') === 'true');
    if (!enabled) return;

    var box = single.querySelector('.bm-engraving__composer-box');
    var input = single.querySelector('.bm-engraving__text-input--single');
    if (!box || !input) return;

    root.classList.add('bm-engraving--inline');

    // Overlay: symbol image + remove (x), absolutely positioned inside the box
    var overlay = document.createElement('span');
    overlay.className = 'bm-inline-symbol';
    overlay.innerHTML =
      '<img class="bm-inline-symbol__image" alt="">' +
      '<button type="button" class="bm-inline-symbol__remove" aria-label="Remove symbol">&times;</button>';
    box.appendChild(overlay);
    var overlayImg = overlay.querySelector('img');

    // Run after the current event (bm-engraving.js updates the DOM first). setTimeout rather than
    // requestAnimationFrame so it also runs in background tabs.
    function later(fn) { window.setTimeout(fn, 0); }

    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext('2d');

    function selectedSymbolButton() {
      return single.querySelector('[data-symbol-item].is-selected');
    }

    function selectedFont() {
      return picker.querySelector('.bm-engraving-font__input:checked');
    }

    // Show the typed text in the chosen font (incl. size scale, e.g. Allura 1.5x)
    function applyInputFont() {
      var f = selectedFont();
      if (!f) {
        input.style.fontFamily = '';
        input.style.fontWeight = '';
        input.style.fontSize = '';
        return;
      }
      input.style.fontFamily = f.getAttribute('data-font-family');
      input.style.fontWeight = f.getAttribute('data-font-weight') || '';
      input.style.fontSize = '';
      var scale = parseFloat(f.getAttribute('data-font-scale')) || 1;
      if (scale !== 1) {
        // Base size comes from bm-engraving-inline.css (18px); theme rules use !important, so match it
        var base = parseFloat(window.getComputedStyle(input).fontSize) || 18;
        input.style.setProperty('font-size', (base * scale) + 'px', 'important');
      }
    }

    // Width of the typed text as rendered in the input
    function textWidth() {
      var cs = window.getComputedStyle(input);
      ctx.font = [cs.fontStyle, cs.fontWeight, cs.fontSize, cs.fontFamily].join(' ');
      var w = ctx.measureText(input.value).width;
      var ls = parseFloat(cs.letterSpacing);
      if (!isNaN(ls)) w += ls * input.value.length;
      return w;
    }

    function position() {
      var btn = selectedSymbolButton();
      var hasText = input.value.trim().length > 0;

      // Text is required - only show the symbol once there is text to follow
      if (!btn || !hasText || !btn.getAttribute('data-symbol-src')) {
        overlay.classList.remove('is-visible');
        return;
      }

      if (overlayImg.getAttribute('src') !== btn.getAttribute('data-symbol-src')) {
        overlayImg.setAttribute('src', btn.getAttribute('data-symbol-src'));
      }
      overlayImg.setAttribute('alt', btn.getAttribute('data-symbol-label') || '');

      var cs = window.getComputedStyle(input);
      var padLeft = parseFloat(cs.paddingLeft) || 0;
      var gap = 6;
      var left = input.offsetLeft + padLeft + textWidth() - input.scrollLeft + gap;

      // Keep it inside the box
      overlay.style.fontSize = cs.fontSize;
      overlay.classList.add('is-visible');
      var maxLeft = input.offsetLeft + input.clientWidth - overlay.offsetWidth - 4;
      overlay.style.left = Math.max(input.offsetLeft + padLeft, Math.min(left, maxLeft)) + 'px';
    }

    function refresh() {
      applyInputFont();
      later(position);
    }

    input.addEventListener('input', function () { later(position); });
    input.addEventListener('scroll', position);
    input.addEventListener('keyup', position);
    window.addEventListener('resize', position);

    picker.addEventListener('change', function () {
      refresh();
      // Re-measure once the web font file has actually loaded
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(position);
    });

    // bm-engraving.js toggles .is-selected on click - measure after it has run
    single.addEventListener('click', function (event) {
      if (event.target.closest('[data-symbol-item]')) later(position);
    });

    // x on the inline symbol = click the selected symbol again (bm-engraving.js toggles it off)
    overlay.querySelector('.bm-inline-symbol__remove').addEventListener('click', function (event) {
      event.preventDefault();
      var btn = selectedSymbolButton();
      if (btn) btn.click();
      later(position);
    });

    if (document.fonts && document.fonts.ready) document.fonts.ready.then(refresh);
    refresh();
    // Values restored by the Ring style carry-over happen on the same tick - check again shortly after
    setTimeout(refresh, 300);
  });
})();
